/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Backup_Form_LabelInputs */

const en_options_backup_form_label = /** @type {(inputs: Options_Backup_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatic Backup Settings`)
};

const fr_options_backup_form_label = /** @type {(inputs: Options_Backup_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paramètres de sauvegarde automatique`)
};

const de_options_backup_form_label = /** @type {(inputs: Options_Backup_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einstellungen für automatische Datensicherung`)
};

const it_options_backup_form_label = /** @type {(inputs: Options_Backup_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impostazioni di backup automatico`)
};

const ru_options_backup_form_label = /** @type {(inputs: Options_Backup_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Настройки автоматического резервного копирования`)
};

const es_options_backup_form_label = /** @type {(inputs: Options_Backup_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configuración de copia de seguridad automática`)
};

const zh_cn2_options_backup_form_label = /** @type {(inputs: Options_Backup_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自动备份设置`)
};

const ja_options_backup_form_label = /** @type {(inputs: Options_Backup_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自動バックアップ設定`)
};

const hi_options_backup_form_label = /** @type {(inputs: Options_Backup_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्वचालित बैकअप सेटिंग्स`)
};

const pt_pt2_options_backup_form_label = /** @type {(inputs: Options_Backup_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configurações de backup automático`)
};

/**
* | output |
* | --- |
* | "Automatic Backup Settings" |
*
* @param {Options_Backup_Form_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_backup_form_label = /** @type {((inputs?: Options_Backup_Form_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Backup_Form_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_backup_form_label(inputs)
	if (locale === "de") return de_options_backup_form_label(inputs)
	if (locale === "it") return it_options_backup_form_label(inputs)
	if (locale === "ru") return ru_options_backup_form_label(inputs)
	if (locale === "es") return es_options_backup_form_label(inputs)
	if (locale === "zh-CN") return zh_cn2_options_backup_form_label(inputs)
	if (locale === "ja") return ja_options_backup_form_label(inputs)
	if (locale === "hi") return hi_options_backup_form_label(inputs)
	if (locale === "pt-PT") return pt_pt2_options_backup_form_label(inputs)
	return en_options_backup_form_label(inputs)
});